var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-export-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-export-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-export-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._m(0),
              _vm._m(1),
              _c(
                "label",
                {
                  staticClass: "wkb-export-label",
                  attrs: { for: "wkb-export-filename" },
                },
                [_vm._v("File name")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localFilename,
                    expression: "localFilename",
                  },
                ],
                ref: "filenameInput",
                staticClass: "wkb-export-input",
                attrs: {
                  id: "wkb-export-filename",
                  type: "text",
                  maxlength: "160",
                  placeholder: "reveal-kg-graph-my-graph.json",
                },
                domProps: { value: _vm.localFilename },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.preventDefault()
                    return _vm.onExport.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.localFilename = $event.target.value
                  },
                },
              }),
              _vm.summary
                ? _c("p", { staticClass: "wkb-export-summary" }, [
                    _vm._v(_vm._s(_vm.summary)),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "wkb-export-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "wkb-export-btn wkb-export-btn-secondary",
                    attrs: { type: "button", disabled: _vm.exporting },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "wkb-export-btn wkb-export-btn-primary",
                    attrs: {
                      type: "button",
                      disabled: !_vm.canExport || _vm.exporting,
                    },
                    on: { click: _vm.onExport },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.exporting ? "Exporting…" : "Export") +
                        " "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "wkb-export-head" }, [
      _c("h2", { attrs: { id: "wkb-export-title" } }, [_vm._v("Export graph")]),
      _c("p", { staticClass: "wkb-export-intro" }, [
        _vm._v(
          " Download a workflow file with the full graph, inspector data, graph explanations, and build-hypotheses results (pathways plus generated hypothesis text) so you can rebuild this session later with "
        ),
        _c("strong", [_vm._v("Manage → Import graph")]),
        _vm._v(". "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticClass: "wkb-export-note", attrs: { role: "note" } },
      [
        _vm._v(" In supported browsers, "),
        _c("strong", [_vm._v("Export")]),
        _vm._v(
          " opens your system save dialog so you can choose the folder. Otherwise the file is saved to your default Downloads folder using the name below. "
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }